// import React, { useState, useEffect } from "react";

// const SelectNetworkDropdown = () => {
//   // Predefined list of networks
//   const availableNetworks = [
//     {
//       name: "Ethereum Mainnet",
//       chainId: 1,
//       rpcUrl: "https://mainnet.infura.io/v3/e71d39d9d58b4736ae7dcba730bc1f18",
//       blockExplorer: "https://etherscan.io",
//       status: false,
//     },
//     {
//       name: "Sepolia testnet",
//       chainId: 11155111,
//       rpcUrl: "https://sepolia.infura.io/v3/e71d39d9d58b4736ae7dcba730bc1f18",
//       blockExplorer: "https://sepolia.etherscan.io/",
//       status: false,
//     },
//     {
//       name: "Polygon",
//       chainId: 137,
//       rpcUrl: "https://polygon-mainnet.infura.io/v3/e71d39d9d58b4736ae7dcba730bc1f18",
//       blockExplorer: "https://polygonscan.com",
//       status: false,
//     },
//     {
//       name: "Polygon Amoy",
//       chainId: 80002,
//       rpcUrl: "https://polygon-amoy.infura.io/v3/e71d39d9d58b4736ae7dcba730bc1f18",
//       blockExplorer: "https://amoy.polygonscan.com/",
//       status: false,
//     },
//     {
//       name: "BSC",
//       chainId: 56,
//       rpcUrl: "https://bsc-mainnet.infura.io/v3/e71d39d9d58b4736ae7dcba730bc1f18",
//       blockExplorer: "https://bscscan.com/",
//       status: false,
//     },
//     {
//       name: "BSC testnet",
//       chainId: 97,
//       rpcUrl: "https://bsc-testnet.infura.io/v3/e71d39d9d58b4736ae7dcba730bc1f18",
//       blockExplorer: "https://testnet.bscscan.com/",
//       status: false,
//     },
//     {
//       name: "Avalanche C-Chain Mainnet",
//       chainId: 43114,
//       rpcUrl: "https://avalanche-mainnet.infura.io/v3/e71d39d9d58b4736ae7dcba730bc1f18",
//       blockExplorer: "https://avascan.info/blockchain/playdapp/tx/0x5c76035bc8836e8f69d3c8dfbef867b5aa4207037a31aa8af7e27471a43aeb1e",
//       status: false,
//     },
//     {
//       name: "Solana DevNet",
//       chainId: 103,
//       rpcUrl: "https://rpc.ankr.com/solana_devnet",
//       blockExplorer: "https://testnet.avascan.info/blockchain/c/tx/0x80bbe295fa78de4cbbaf94e2e3f76b82253a1b96fc17e78377060d16b2b0331e",
//       status: false,
//     },
//     {
//       name: "Solana MainNet",
//       chainId: 101,
//       rpcUrl: "https://api.mainnet-beta.solana.com",
//       blockExplorer: "https://testnet.avascan.info/blockchain/c/tx/0x80bbe295fa78de4cbbaf94e2e3f76b82253a1b96fc17e78377060d16b2b0331e",
//       status: false,
//     },
//   ];

//   // Initialize state for the active network, defaulting to Ethereum Mainnet (chainId: 1)
//   const [activeNetwork, setActiveNetwork] = useState(
//     availableNetworks.find((network) => network.chainId === 1) // Default to Ethereum Mainnet
//   );

//   // Handle network selection
//   const handleSelectChange = (e) => {
//     const selectedChainId = parseInt(e.target.value);
//     const network = availableNetworks.find((net) => net.chainId === selectedChainId);
//     setActiveNetwork(network);  // Update the active network
//   };

//   return (
//     <div style={{ margin: "20px" }}>
//       <h3>Select Active Network</h3>
//       <select
//         onChange={handleSelectChange}
//         value={activeNetwork?.chainId || ""}
//         style={{ padding: "10px", fontSize: "16px", marginBottom: "20px" }}
//       >
//         <option value="" disabled>
//           Select a Network
//         </option>
//         {availableNetworks.map((network) => (
//           <option key={network.chainId} value={network.chainId}>
//             {network.name}
//           </option>
//         ))}
//       </select>

//       {/* Display the selected network's information */}
//       {activeNetwork && (
//         <div style={{ marginTop: "30px" }}>
//           <h4>Selected Network</h4>
//           <p>
//             <strong>Name:</strong> {activeNetwork.name}
//           </p>
//           <p>
//             <strong>Chain ID:</strong> {activeNetwork.chainId}
//           </p>
         
//         </div>
//       )}
//     </div>
//   );
// };

// export default SelectNetworkDropdown;

import React from 'react'

const SelectNetworkDropdown = () => {
  return (
    <div>SelectNetworkDropdown</div>
  )
}

export default SelectNetworkDropdown